import { render, staticRenderFns } from "./PlatformInfiniteScroll.vue?vue&type=template&id=43bd2c30"
import script from "./PlatformInfiniteScroll.vue?vue&type=script&lang=ts"
export * from "./PlatformInfiniteScroll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports